import $ from 'jquery';
 

export default function objectFit() {
    $(".object-cover").each(function () {
        var imgSrc = $(this).attr('src');
        var fitType = 'cover';

        if ($(this).data('fit-type')) {
            fitType = $(this).data('fit-type');
        }

        $(this).parent().css({
            'background': `transparent url(" ${imgSrc} ") no-repeat center center/${fitType}` });
        $(this).remove();
    });
}
